<template>
  <ReportWrapper class="h-full w-full xl:!pl-[10px] xl:!mt-0 mt-[50px]">
    <template #actions>
      <CfsDateField v-model="selectedDateRange" placeholder="Date" range />

      <CfsDropdown
        :disabled="!selectedDateRange"
        btn-class="ml-auto"
        icon="mdi-tray-arrow-down"
        medium
        :loading="isLoading"
        color="primary"
        btn-width="32px"
        title="Download"
        offset-x
        :btn-type-text="false"
        :min-width="175"
        nudge-bottom="6px"
        rounded-menu="lg"
        :items="dropdownOptions"
      />
    </template>
  </ReportWrapper>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useReports } from '@/composables/reports/useReports';
import { downloadFileByType } from '@/helpers/download';
import { DocumentTypes, OutputTypes } from '@/constants/reports';
import date from '@/extensions/filters/date';
import DownloadIcon from '@/assets/img/icons/download/download-with-circle.svg';
import ReportWrapper from '@/components/reports/ReportWrapper.vue';
import { useToast } from '@/composables/useToast';

export default defineComponent({
  name: 'CreditMemoAuditReport',
  components: {
    ReportWrapper,
  },

  setup() {
    const toast = useToast();
    const { useDownloadInternalInventoryReport } = useReports();
    const { mutateAsync: downloadReport, isLoading } = useDownloadInternalInventoryReport();

    const selectedDateRange = ref<{ start: string; end: string } | null>(null);

    const download = async (outputType: string) => {
      if (!selectedDateRange.value) return toast.info('Please select date.');

      try {
        const { data } = await downloadReport({
          fromdate: selectedDateRange.value?.start,
          todate: selectedDateRange.value?.end,
          outputType,
          documentType: DocumentTypes.CREDIT_MEMO_AUDIT,
        });

        if (!data) return;

        downloadFileByType(data, `Credit Memo Audit ${date(new Date())}`, outputType);
      } catch (error) {
        console.error(error);
      }
    };

    const dropdownOptions = [
      {
        title: 'Download XLSX',
        icon: DownloadIcon,
        iconWidth: 20,
        handler: () => download(OutputTypes.XLSX),
      },
      {
        title: 'Download PDF',
        icon: DownloadIcon,
        iconWidth: 20,
        handler: () => download(OutputTypes.PDF),
      },
      {
        title: 'Download DOCX',
        icon: DownloadIcon,
        iconWidth: 20,
        handler: () => download(OutputTypes.DOCX),
      },
    ];

    return { isLoading, dropdownOptions, selectedDateRange };
  },
});
</script>
